import '../../VendorStyles/Dashboard.css';
import { useState, useEffect } from 'react';
import img1 from '../../assets/TotalOrders.png';
import img2 from '../../assets/Totaldelivered.png';
import img3 from '../../assets/cancelled.png';
import img4 from '../../assets/Totalrevenue.png';

import axiosVendorInstance from '../../axiosVendorInstance';

import {
    Menu,
    MenuItem,
    Button,
    Box,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    styled,
    Stack,
    Pagination,
    FormControl,
    InputLabel,
    Select,
} from '@mui/material';
import { FaCalendarAlt } from 'react-icons/fa';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import CommonButton from '../../Components/commonButton';
import Loader from '../../Components/Loader/Loader';
import VendorOrderDetailModal from './VendorOrderDetailModal';

function Dashboard() {
    const [vendorID, setVendorID] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderData, setOrderData] = useState({
        totalOrders: 0,
        totalDelivered: 0,
        cancelledOrders: 0,
        totalRevenue: 0,
    });
    const [tableOrderData, setTableOrderData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedOption, setSelectedOption] = useState('All');
    const [showCustom, setShowCustom] = useState(false);
    const [customDate, setCustomDate] = useState({ start: null, end: null });
    const [pageNo, setPageNo] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [appliedDates, setAppliedDates] = useState({
        start: null,
        end: null,
    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setShowCustom(false);
    };

    const handleOptionClick = (option) => {
        if (option === 'Custom') {
            setSelectedOption('Custom');
            setShowCustom(true);
        } else {
            setSelectedOption(option);
            setShowCustom(false);
            handleClose();
        }
    };

    const fetchVendorID = async () => {
        setLoading(true);
        const vendorResponse = await axiosVendorInstance.get('/vendors/account');
        setVendorID(vendorResponse?.data?.getVendorInfo[0]?.ID);
    };

    useEffect(() => {
        fetchVendorID();
    }, [vendorID, pageNo]);

    const fetchOrderData = async (
        startDate = appliedDates.start,
        endDate = appliedDates.end,
        status = selectedStatus
    ) => {
        try {
            const url =
        `/Order/vendor/${vendorID}?pageSize=10&pageNumber=${pageNo}` +
        (status ? `&statusId=${status}` : '') +
        (startDate && endDate
            ? `&startDate=${startDate}&endDate=${endDate}`
            : '');

            const response = await axiosVendorInstance.get(url);
            if (response?.data && response?.data?.allOrdersDetails) {
                setTableOrderData(response?.data?.allOrdersDetails);
                setTotalPages(response?.data?.totalPages || 1);
            } else {
                setTableOrderData([]);
                setTotalPages(1);
            }
            const totalOrdersCount = response?.data?.totalOrders;
            const totalDeliveredCount = response?.data?.deliveredOrders;
            const totalDeclinedCount = response?.data?.declinedOrders;
            const totalEarnings = response?.data?.totalRevenue;

            setOrderData({
                totalOrders: totalOrdersCount,
                totalDelivered: totalDeliveredCount,
                cancelledOrders: totalDeclinedCount,
                totalRevenue: totalEarnings,
            });
        } catch (err) {
            console.error('Error fetching order data:', err);
            setTableOrderData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleApply = () => {
        let startDate, endDate;

        switch (selectedOption) {
        case 'Today':
            startDate = endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Yesterday':
            startDate = endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
            break;
        case 'Last 7 Days':
            startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
            endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Last 30 Days':
            startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
            endDate = dayjs().format('YYYY-MM-DD');
            break;
        case 'Custom':
            if (customDate?.start && customDate?.end) {
                startDate = dayjs(customDate?.start).format('YYYY-MM-DD');
                endDate = dayjs(customDate?.end).format('YYYY-MM-DD');
            } else {
                return;
            }
            break;
        case 'All':
            startDate = null;
            endDate = null;
            break;
        default:
            return;
        }

        setLoading(true);
        setAppliedDates({ start: startDate, end: endDate });
        setPageNo(1);
        fetchOrderData(startDate, endDate, selectedStatus);
        handleClose();
    };

    const handleClear = () => {
        setLoading(true);
        setSelectedStatus(0);
        setSelectedOption('All');
        setCustomDate({ start: null, end: null });
        setShowCustom(false);
        setPageNo(1);
        setAppliedDates({ start: null, end: null });
        fetchOrderData(null, null, null);
    };

    const handlePageChange = (event, value) => {
        setPageNo(value);
    };

    useEffect(() => {
        if (vendorID) {
            setLoading(true);
            fetchOrderData();
        }
    }, [vendorID, pageNo]);

    const Orders = [
        { image: img1, count: orderData?.totalOrders ?? 0, type: 'Total Orders' },
        {
            image: img2,
            count: orderData?.totalDelivered ?? 0,
            type: 'Total Delivered',
        },
        { image: img3, count: orderData?.cancelledOrders ?? 0, type: 'Declined' },
        {
            image: img4,
            count: `$${orderData?.totalRevenue ?? 0}`,
            type: 'Total Revenue',
        },
    ];

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        backgroundColor: '#e5e8f1',
        color: theme.palette.common.black,
        fontWeight: 'bold',
        fontFamily: 'var(--font-family)',
    }));

    const handleStatusChange = (event) => {
        const value = event.target.value;
        const parsedValue = value === '' ? null : Number(value);
        setSelectedStatus(parsedValue);
    };

    return (
        <>
            <VendorSideMenuBar />
            <VendorTopMenuBar />
            <div className='menu-main-container-vendor'>
                <div className='vendor-common-container'>
                    <div className='orders-page'>
                        <div className='dashboard-top1-container'>
                            <div className='order-filter-apply-container'>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                        {/* Dropdown Toggle Button */}
                                        <Button
                                            variant='outlined'
                                            startIcon={<FaCalendarAlt />}
                                            onClick={handleClick}
                                            className='date-dropdown-btn'
                                        >
                                            {selectedOption}
                                        </Button>

                                        {/* Dropdown Menu */}
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                        >
                                            {!showCustom ? (
                                                <>
                                                    {[
                                                        'All',
                                                        'Today',
                                                        'Yesterday',
                                                        'Last 7 Days',
                                                        'Last 30 Days',
                                                        'Custom',
                                                    ].map((option) => (
                                                        <MenuItem
                                                            key={option}
                                                            onClick={() => handleOptionClick(option)}
                                                        >
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </>
                                            ) : (
                                                <Box sx={{ p: 2, width: { xs: '100%', sm: 350 } }}>
                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                        <DatePicker
                                                            label='Start Date'
                                                            value={customDate.start}
                                                            onChange={(date) =>
                                                                setCustomDate({ ...customDate, start: date })
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField {...params} fullWidth />
                                                            )}
                                                        />
                                                        <DatePicker
                                                            label='End Date'
                                                            value={customDate.end}
                                                            onChange={(date) =>
                                                                setCustomDate({ ...customDate, end: date })
                                                            }
                                                            minDate={customDate.start}
                                                            renderInput={(params) => (
                                                                <TextField {...params} fullWidth />
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            mt: 2,
                                                        }}
                                                    >
                                                        <Button
                                                            className='custom-apply-btn'
                                                            variant='outlined'
                                                            onClick={handleClose}
                                                        >
                              Cancel
                                                        </Button>
                                                        <Button
                                                            className='custom-apply-btn'
                                                            variant='contained'
                                                            onClick={handleApply}
                                                        >
                              Apply
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Menu>
                                    </Box>
                                </LocalizationProvider>
                                <div className='filter-container'>
                                    <FormControl
                                        variant='outlined'
                                        slotProps={{ textField: { size: 'small' } }}
                                        sx={{
                                            minWidth: 200,
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#6D7383',
                                                },
                                            },
                                        }}
                                    >
                                        <>
                                            <InputLabel>Status</InputLabel>
                                            <Select
                                                value={selectedStatus}
                                                onChange={handleStatusChange}
                                                label='Status'
                                            >
                                                <MenuItem value={0}>All</MenuItem>
                                                <MenuItem value={1}>Order Placed</MenuItem>
                                                <MenuItem value={2}>Preparing</MenuItem>
                                                <MenuItem value={3}>Declined</MenuItem>
                                                <MenuItem value={5}>Pickup</MenuItem>
                                                <MenuItem value={6}>Delivered</MenuItem>
                                                <MenuItem value={7}>In-Transit</MenuItem>
                                            </Select>
                                        </>
                                    </FormControl>
                                </div>
                                <CommonButton
                                    label={'Apply'}
                                    onClick={handleApply}
                                    style={{ height: '42px' }}
                                />
                                <CommonButton
                                    label={'Clear'}
                                    onClick={handleClear}
                                    style={{ height: '42px' }}
                                />
                            </div>
                        </div>
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className='dashboard-bottom-container'>
                                    {Orders?.map((order, index) => (
                                        <div
                                            key={index}
                                            className='dashboard-bottom-single-container'
                                        >
                                            <div className='dashboard-order-img'>
                                                <img src={order?.image}></img>
                                            </div>
                                            <div className='dashboard-order-count-and-type'>
                                                <h5 className='dashboard-order-count'>
                                                    {order?.count}
                                                </h5>
                                                <h5 className='dashboard-order-type'>{order?.type}</h5>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {tableOrderData && tableOrderData?.length > 0 ? (
                                    <>
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                borderRadius: 2,
                                                boxShadow: 3,
                                                maxHeight: 500,
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                width: '100%',
                                            }}
                                        >
                                            <Table stickyHeader sx={{ minWidth: 900 }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Order ID</StyledTableCell>
                                                        <StyledTableCell>Items</StyledTableCell>
                                                        <StyledTableCell>Customer Name</StyledTableCell>
                                                        <StyledTableCell>Date</StyledTableCell>
                                                        <StyledTableCell>Status</StyledTableCell>
                                                        <StyledTableCell>Action</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableOrderData?.map((order) => (
                                                        <TableRow
                                                            key={order?.id}
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: '#f5f5f5',
                                                                    cursor: 'pointer',
                                                                },
                                                                transition: 'background-color 0.3s ease-in-out',
                                                            }}
                                                            onClick={() => {
                                                                setSelectedOrder(order);
                                                                setModalOpen(true);
                                                            }}
                                                        >
                                                            <TableCell>{order?.ID}</TableCell>
                                                            <TableCell>{order?.order_info?.length}</TableCell>
                                                            <TableCell>
                                                                {order?.user
                                                                    ? `${order?.user?.first_name} ${order?.user?.last_name}`
                                                                    : 'N/A'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {new Date(order?.Created_at)
                                                                    .getDate()
                                                                    .toString()
                                                                    .padStart(2, '0')}
                                -
                                                                {(new Date(order?.Created_at).getMonth() + 1)
                                                                    .toString()
                                                                    .padStart(2, '0')}
                                -{new Date(order?.Created_at).getFullYear()}{' '}
                                                                {new Date(
                                                                    order?.Created_at
                                                                ).toLocaleTimeString()}
                                                            </TableCell>
                                                            <TableCell>
                                                                {{
                                                                    1: 'Order Placed',
                                                                    2: 'Preparing',
                                                                    3: 'Declined',
                                                                    5: 'Pickup',
                                                                    6: 'Delivered',
                                                                    7: 'In-Transit',
                                                                }[order?.Status_id] || 'Unknown'}
                                                            </TableCell>
                                                            <TableCell>
                                                                <CommonButton
                                                                    label={'View'}
                                                                    onClick={() => {
                                                                        setSelectedOrder(order);
                                                                        setModalOpen(true);
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Stack spacing={2}>
                                            <Pagination
                                                sx={{
                                                    '& .MuiPagination-ul': {
                                                        color: '#333',
                                                        padding: 1,
                                                        borderRadius: 2,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        listStyleType: 'none',
                                                    },
                                                }}
                                                count={totalPages}
                                                page={pageNo}
                                                onChange={handlePageChange}
                                                showFirstButton
                                                showLastButton
                                            />
                                        </Stack>
                                    </>
                                ) : (
                                    <>
                                        <div className='no-order11'>
                                            <p>No Orders Found</p>
                                        </div>
                                    </>
                                )}
                                {selectedOrder && (
                                    <VendorOrderDetailModal
                                        open={modalOpen}
                                        handleClose={() => {
                                            setModalOpen(false);
                                            setSelectedOrder(null);
                                        }}
                                        id={selectedOrder.ID}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
